<div class="ey-nav-container" [ngClass]="{ 'ey-nav-sideCollapsed': sideExpanded === false, 'ey-nav-topCollapsed': topExpanded === false }">
  <div>
    <div class="ey-header-container">
      <a tabindex="1" class="navbar-brand" [routerLink]="['/']">
        <img src="assets/images/EY Logo.png" alt="Logo" />
        <span class="ey-home-title">TP Benchmark</span>
      </a>
      <button
        tabindex="1"
        type="button"
        class="btn btn-link ey-menu-slide-button"
        (click)="toggleSide()"
        ngbTooltip="{{ 'navigationMenu' | tpbTooltip }}"
        placement="right-top"
      >
        <i class="ey-collapse-icon material-icons">menu</i>
        <i class="ey-expand-icon material-icons">menu</i>
      </button>
      <button tabindex="1" type="button" class="btn btn-link ey-menu-button" (click)="toggleTop()">
        <i class="material-icons">menu</i>
      </button>
    </div>
    <div class="ey-nav-items-container">
      <ul class="nav flex-column">
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="[linkDashboard]" class="nav-link" (click)="closeTop()" tabindex="1" aria-label="Dashboard">
            <i class="ey-menu-icon material-icons">dashboard</i>
            <span class="ey-menu-text">Dashboard</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="[linkSearchStudies]" class="nav-link" (click)="closeTop()" tabindex="1" aria-label="Search Studies">
            <i class="ey-menu-icon material-icons">search</i>
            <span class="ey-menu-text">Search Studies</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="[linkMyStudies]" class="nav-link" (click)="closeTop()" tabindex="1" aria-label="My Studies">
            <i class="ey-menu-icon material-icons">card_travel</i>
            <span class="ey-menu-text">My Studies</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" [class.active]="isLegacyStudy">
          <a  class="nav-link" (click)="gotoNonAIStudies()" tabindex="1" aria-label="Non Gen AI Studies">
            <i class="ey-menu-icon material-icons">archive</i>
            <span class="ey-menu-text">Non Gen AI Studies</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/admin']" class="nav-link" (click)="toggleTop()" tabindex="1" aria-label="Admin">
            <i class="ey-menu-icon material-icons">person_outline</i>
            <span class="ey-menu-text">Admin</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/privacynotice']" class="nav-link" (click)="toggleTop()" tabindex="1" aria-label="Privacy Notice">
            <i class="ey-menu-icon material-icons">note</i>
            <span class="ey-menu-text">Privacy Notice</span>
          </a>
        </li>
        <li>
          <a #notificationAnchor href (click)="showNotificationsDialog(notificationAnchor)" class="nav-link" tabindex="1" aria-label="Notifications">
            <span class="ey-menu-icon"><app-notification-indicator></app-notification-indicator></span>
            <span class="ey-menu-text">Notifications</span>
          </a>
        </li>
        <li class="ey-nav-logout">
          <a
            href
            class="nav-link"
            *ngIf="loggedIn === true"
            (click)="$event.preventDefault(); logOut()"
            title="Logout User: {{ currentUser?.displayName }} - ({{ currentUser?.userPrincipalName }})"
            tabindex="1"
          >
            <i class="ey-menu-icon material-icons">exit_to_app</i>
            <span class="ey-menu-text">Logout</span>
          </a>
        </li>
      </ul>
      <div
        style="font-size: 10px; color: #616161; padding-left: 1.5rem"
        *ngIf="currentUser !== undefined && sideExpanded && (apiBuildVersion$ | async) !== undefined"
      >
        <div *ngIf="sideExpanded">
          <span>{{ this.apiBuildVersion$ | async }}</span>
        </div>
      </div>
      <div style="font-size: 14px; color: black; padding-left: 0.5rem; margin-top: 0.5rem">
        <div *ngIf="sideExpanded">
          <i class="material-icons ev-nav-version-mark" style="padding-right: 0.5rem">check_circle</i>
          <span style="background-color: #ffe600; color: black; padding-right: 0.5rem">
            <span *ngIf="isGenerativeAiEnabled">{{ tpbmVersion }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
